// Author YuJiaBei
// Date 2022-02-28 09:25:36

import * as model from "@/model/sithMes/prd/SithMesPrdProjectPlanDetailPpdModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdProjectPlanDetailPpd(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesPrdProjectPlanDetailPpd',
        modelFilter: model.filter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'levelTreeFilter',
        filterInitializer: newFilter
    })
    .buildStore()
